import React, { useState, useEffect } from "react";

const Popup = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {

        const today = new Date();
        const limitDate = new Date("2026-09-01T00:00:00");
        //yy-mm-dd

        if (today < limitDate) {
            setVisible(true);
        }
    }, []);

    const closePopup = () => {
        localStorage.setItem("bevrijdingsdag-popup-closed", "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.popup}>
                <h2 style={styles.h2}>Let op!</h2>
                <p>Wij zijn van <strong>maandag 17 augustus tot dinsdag 1 september</strong> gesloten wegens vakantie!</p>
                <p><strong>Vanaf woensdag 2 september zijn wij weer geopend!</strong></p>
                <button style={styles.button} onClick={closePopup}>Sluiten</button>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0,
        width: "100vw", height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999,
    },
    popup: {
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "10px",
        border: "solid 5px #997330",
        textAlign: "center",
        maxWidth: "90%",
        boxShadow: "0 0 15px rgba(0,0,0,0.3)"
    },
    h2: {
        fontSize: "24px ",
        marginBottom: "15px",
    },
    button: {
        marginTop: "25px",
        fontSize: "18px",
        padding: "10px 30px",
        backgroundColor: "#97aa8f",
        color: "#fff",
        border: "solid #997330 2px",
        borderRadius: "5px",
        cursor: "pointer",
    }
};

export default Popup;
